// This implements a mocking system for localStorage in tests

const localStorageMock = (() => {
    let store = {};

    return {
        getItem: key => store[key] || null,
        setItem: (key, value) => {
            store[key] = value.toString();
        },
        clear: () => {
            store = {};
        },
    };
})();

Object.defineProperty(window, 'localStorage', {
    value: localStorageMock,
});



/** WEBPACK FOOTER **
 ** ./src/utils/test-utils/browserMocks.js
 **/